'use strict'

window.OrderReportWorklistShared = {
    checkAndSetRoomFilterActive: () => {
        const roomFilterDefault = true;

        OrderReportWorklistShared.checkAndSetMultiSelectFilterIsActive(".visibleRooms", ".checkRoomVis", roomFilterDefault);
    },
    checkAndSetMultiSelectFilterIsActive: (containerSelector, childCheckboxesSelector, defaul) => {
        const filterContainer = $(containerSelector);
        const checkboxes = $(filterContainer).find(childCheckboxesSelector);
        const anyNotSetToDefault = Array.from($(checkboxes).map((i,e) => e))
            .reduce((acc, e) => { return acc || (e.checked) !== defaul} , false);

        $(filterContainer).toggleClass("active-filter", anyNotSetToDefault);
    }
};